import { render, staticRenderFns } from "./RecipientAddress.vue?vue&type=template&id=6b7dfb0e"
import script from "./RecipientAddress.vue?vue&type=script&lang=js"
export * from "./RecipientAddress.vue?vue&type=script&lang=js"
import style0 from "./RecipientAddress.vue?vue&type=style&index=0&id=6b7dfb0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports